(function(){'use strict';
var lb=null,images=[],currentIdx=0,startX=0,isDragging=false,featureTimer=null,keyFeatures=[];

function extractFeatures(){
  var items=[];
  var ps=document.querySelectorAll('.product__description p');
  for(var pi=0;pi<ps.length;pi++){
    var text=ps[pi].innerText||ps[pi].textContent;
    var matches=text.match(/\ud83d\udeab\s*[^\n\u00b7\u2022\ud83d\udeab]+/g);
    if(matches&&matches.length>=2){
      matches.forEach(function(m){
        var clean=m.replace('\ud83d\udeab','').trim().replace(/\s+/g,' ');
        if(clean.length<40)items.push({icon:'\u2715',text:clean});
      });
      if(items.length>=2)return items.slice(0,5);
    }
  }
  return[
    {icon:'\u2713',text:'Alcohol Free'},
    {icon:'\u2713',text:'SLS Free'},
    {icon:'\u2713',text:'Paraben Free'},
    {icon:'\u2713',text:'Mineral Oil Free'},
    {icon:'\u2713',text:'Cruelty Free'}
  ];
}

function buildLightbox(){
  if(document.getElementById('oa-lb'))return;
  var el=document.createElement('div');
  el.id='oa-lb';
  el.setAttribute('role','dialog');
  el.setAttribute('aria-modal','true');
  el.innerHTML='<div class="oa-lb-backdrop"></div><button class="oa-lb-prev" aria-label="Previous" style="display:none;"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-arrow-left" viewBox="0 0 8 8"><path d="M5 1L2 4l3 3" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button><div class="oa-lb-wrap"><button class="oa-lb-close" aria-label="Close">&times;</button><div class="oa-lb-track-wrap"><div class="oa-lb-track"></div></div><div class="oa-lb-features" aria-hidden="true"><div class="oa-lb-features-inner"></div></div><div class="oa-lb-counter"></div><div class="oa-lb-dots"></div></div><button class="oa-lb-next" aria-label="Next" style="display:none;"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-arrow-right" viewBox="0 0 8 8"><path d="M3 1l3 3-3 3" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>';
  document.body.appendChild(el);
  lb=el;
  el.querySelector('.oa-lb-backdrop').addEventListener('click',closeLightbox);
  el.querySelector('.oa-lb-close').addEventListener('click',closeLightbox);
  el.querySelector('.oa-lb-prev').addEventListener('click', function(e) {
    e.stopPropagation();
    prev();
  });
  el.querySelector('.oa-lb-next').addEventListener('click', function(e) {
    e.stopPropagation();
    next();
  });
  document.addEventListener('keydown',onKey);
  var track=el.querySelector('.oa-lb-track');
  track.addEventListener('touchstart',onTouchStart,{passive:true});
  track.addEventListener('touchend',onTouchEnd);
  track.addEventListener('mousedown',onMouseDown);
  document.addEventListener('mouseup',onMouseUp);
}

function collectImages(){
  images=[];
  var seen={};
  var containers=document.querySelectorAll('.product__image-container:not(.hide),.product__subimage-list-item');
  containers.forEach(function(c){
    var img=c.querySelector('img');
    var link=c.querySelector('a');
    if(!img)return;
    var src=img.getAttribute('data-src')||img.src||'';
    src=src.replace(/_{width}x\./, '_master.').replace(/_\d+x\d*\./, '_master.').replace(/_\d+x\./, '_master.');
    if(link&&link.href&&/\.(jpg|jpeg|png|webp)/i.test(link.href))src=link.href;
    var id=(c.getAttribute('data-id'))||(img.getAttribute('data-id'))||src;
    if(seen[id])return;
    seen[id]=true;
    images.push({src:src,alt:img.alt||'',id:id});
  });
  var srcSeen={};
  images=images.filter(function(im){if(srcSeen[im.src])return false;srcSeen[im.src]=true;return true;});
}

function renderSlides(){
  var track=lb.querySelector('.oa-lb-track');
  var dots=lb.querySelector('.oa-lb-dots');
  track.innerHTML='';dots.innerHTML='';
  images.forEach(function(im,i){
    var slide=document.createElement('div');
    slide.className='oa-lb-slide';
    slide.dataset.index=i;
    var img=document.createElement('img');
    img.src=im.src;img.alt=im.alt;img.draggable=false;
    slide.appendChild(img);track.appendChild(slide);
    var dot=document.createElement('button');
    dot.className='oa-lb-dot'+(i===0?' active':'');
    dot.setAttribute('aria-label','Image '+(i+1));
    dot.dataset.index=i;
    dot.addEventListener('click',function(){goTo(parseInt(this.dataset.index));});
    dots.appendChild(dot);
  });
}

function buildFeaturesHTML(){
  var inner=lb.querySelector('.oa-lb-features-inner');
  inner.innerHTML='';
  keyFeatures.forEach(function(f){
    var item=document.createElement('div');
    item.className='oa-lb-feat-item';
    item.innerHTML='<span class="oa-lb-feat-icon">'+f.icon+'</span><span class="oa-lb-feat-text">'+f.text+'</span>';
    inner.appendChild(item);
  });
}

function showFeatures(){
  clearTimeout(featureTimer);
  featureTimer=setTimeout(function(){
    var feat=lb.querySelector('.oa-lb-features');
    if(feat)feat.classList.add('visible');
  },500);
}

function hideFeatures(){
  clearTimeout(featureTimer);
  var feat=lb&&lb.querySelector('.oa-lb-features');
  if(feat)feat.classList.remove('visible');
}

function goTo(idx){
  if(idx<0||idx>=images.length)return;
  hideFeatures();
  currentIdx=idx;
  var track=lb.querySelector('.oa-lb-track');
  track.style.transform='translateX(-'+(idx*100)+'%)';
  lb.querySelectorAll('.oa-lb-dot').forEach(function(d,i){d.classList.toggle('active',i===idx);});
  lb.querySelector('.oa-lb-counter').textContent=(idx+1)+' / '+images.length;
  
  // Update prev/next navigation states
  var prevBtn = lb.querySelector('.oa-lb-prev');
  var nextBtn = lb.querySelector('.oa-lb-next');
  if (prevBtn && nextBtn) {
    if (images.length <= 1) {
      prevBtn.style.display = 'none';
      nextBtn.style.display = 'none';
    } else {
      prevBtn.style.display = '';
      nextBtn.style.display = '';
      prevBtn.style.opacity = idx === 0 ? '0.2' : '1';
      prevBtn.style.pointerEvents = idx === 0 ? 'none' : 'auto';
      nextBtn.style.opacity = idx === images.length - 1 ? '0.2' : '1';
      nextBtn.style.pointerEvents = idx === images.length - 1 ? 'none' : 'auto';
    }
  }

  if(idx===0||idx===images.length-1)showFeatures();
}

function next(){goTo(Math.min(currentIdx+1,images.length-1));}
function prev(){goTo(Math.max(currentIdx-1,0));}

function openLightbox(startIndex){
  buildLightbox();
  keyFeatures=extractFeatures();
  collectImages();
  if(images.length===0)return;
  renderSlides();
  buildFeaturesHTML();
  var track=lb.querySelector('.oa-lb-track');
  track.style.transition='none';
  currentIdx=startIndex||0;
  track.style.transform='translateX(-'+(currentIdx*100)+'%)';
  lb.classList.add('open');
  document.body.classList.add('oa-lb-open');
  requestAnimationFrame(function(){
    requestAnimationFrame(function(){
      track.style.transition='transform 0.32s cubic-bezier(0.4,0,0.2,1)';
      goTo(currentIdx);
    });
  });
}

function closeLightbox(){
  if(!lb)return;
  hideFeatures();
  lb.classList.remove('open');
  document.body.classList.remove('oa-lb-open');
}

function onKey(e){
  if(!lb||!lb.classList.contains('open'))return;
  if(e.key==='ArrowRight')next();
  if(e.key==='ArrowLeft')prev();
  if(e.key==='Escape')closeLightbox();
}

function onTouchStart(e){startX=e.touches[0].clientX;}
function onTouchEnd(e){
  var dx=e.changedTouches[0].clientX-startX;
  if(Math.abs(dx)>40){dx<0?next():prev();}
}
function onMouseDown(e){isDragging=true;startX=e.clientX;e.preventDefault();}
function onMouseUp(e){
  if(!isDragging)return;
  isDragging=false;
  var dx=e.clientX-startX;
  if(Math.abs(dx)>40){dx<0?next():prev();}
}

function interceptClicks(){
  document.addEventListener('click',function(e){
    var trigger=e.target.closest('.product__image-wrapper')||e.target.closest('.product__subimage-container')||e.target.closest('.product-slideshow__open');
    if(!trigger)return;
    e.preventDefault();
    e.stopPropagation();
    collectImages();
    var clickedId=trigger.getAttribute('data-id')||(trigger.querySelector('[data-id]')&&trigger.querySelector('[data-id]').getAttribute('data-id'));
    var startIdx=0;
    if(clickedId){images.forEach(function(im,i){if(im.id===clickedId)startIdx=i;});}
    openLightbox(startIdx);
  },true);
}

function init(){
  if(!document.querySelector('.product-template'))return;
  interceptClicks();
}

if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);}else{init();}
})();
